<app-badges [badges]="config.badges"></app-badges>
<div *ngIf="config" #titleContainer class="title-container" [ngStyle]="{'color': color}">
  <div *ngIf="config.header" class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h3 [id]="config.header | stripSpecialChars" [ngStyle]="{'text-align': position == 'full-width' ? 'center' : 'left'}">
          {{config.header}}
        </h3>
        <kla-social-media-buttons class="mb-2" [linkFragment]="config.header"></kla-social-media-buttons>
      </div>
    </div>
  </div>
  <div *ngIf="config.title" class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h3
          *ngIf="!config.header"
          [id]="config.title | stripSpecialChars"
          class="mr-2 title-main"
          [ngStyle]="{'text-align': position == 'full-width' ? 'center' : 'left'}"
          [style.color]="color != '' ? color : null"
        >
          {{ config.title }}
        </h3>
        <h4
          *ngIf="config.header"
          [id]="config.title | stripSpecialChars"
          class="mr-2"
          [ngStyle]="{'text-align': position == 'full-width' ? 'center' : 'left'}"
          [style.color]="color != '' ? color : null"
        >
          {{ config.title }}
        </h4>
        <kla-social-media-buttons class="mb-2" [linkFragment]="config.title"></kla-social-media-buttons>
      </div>
    </div>
  </div>
  <div *ngIf="config.description" class="row">
    <div class="col-12">
      <div [ngStyle]="{'text-align': position == 'full-width' ? 'center' : 'left'}"
        [style.color]="'rgb(76, 88, 103)'">
        <app-dynamic-content
          [contentId]="'title-desc'"
          [htmlContent]="config.description">
        </app-dynamic-content>
      </div>
    </div>
  </div>
  <div class="row block">
    <div class="col-12">
      <ng-content></ng-content>
    </div>
  </div>
  <div *ngIf="config.footer && showFooter" class="row">
    <div class="col-12">
      <p [ngStyle]="{'text-align': position == 'full-width' ? 'center' : 'left'}" [innerHTML]="config.footer"
        [style.color]="color != '' ? color : null"></p>
    </div>
  </div>
</div>
